import {
  STATUS_ERROR,
  STATUS_INITIAL,
  STATUS_PENDING,
  STATUS_SUCCESS,
} from '~/constants';

import { AccountInfoFormState, ActionType } from './model';

export const initialState: AccountInfoFormState = {
  data: null,
  status: STATUS_INITIAL,
  isSaved: false,
  isPristine: true,
};

function logger(type, value = '') {
  console.info(
    `%cDispatcher: ${type} ${value ? `- ${value}` : ''}`,
    'color: #bada55;',
  );
}

function reducer(
  state: AccountInfoFormState,
  action: ActionType,
): AccountInfoFormState {
  switch (action.type) {
    case 'SET_ACCOUNT':
      logger(action.type);
      return {
        ...state,
        data: action.payload.data,
        status: STATUS_SUCCESS,
      };
    case 'SET_IS_PRISTINE':
      logger(action.type);
      return {
        ...state,
        isSaved: false,
        isPristine: action.payload.value,
      };
    case 'SET_ACCOUNT_INFO':
      logger(action.type);
      return {
        ...state,
        status: STATUS_PENDING,
      };
    case 'SET_ACCOUNT_INFO_SUCCESS':
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.data,
        },
        status: STATUS_SUCCESS,
        isPristine: true,
        isSaved: true,
      };
    case 'SET_ACCOUNT_INFO_FAILED':
      logger(action.type);
      return {
        ...state,
        status: STATUS_ERROR,
      };
    case 'UPDATE_PHOTO':
      logger(action.type);
      return {
        ...state,
        status: STATUS_PENDING,
      };
    case 'UPDATE_PHOTO_SUCCESS':
      logger(action.type, JSON.stringify(action.payload.photo));
      return {
        ...state,
        data: {
          ...state.data,
          photo: action.payload.photo,
        },
        status: STATUS_SUCCESS,
      };
    case 'UPDATE_PHOTO_FAILED':
      logger(action.type);
      return {
        ...state,
        status: STATUS_ERROR,
      };
    case 'UPDATE_FIELD_VALUE':
      logger(action.type, JSON.stringify(action.payload));
      return {
        ...state,
        data: { ...state.data, [action.payload.name]: action.payload.value },
      };
  }
}

export default reducer;
